import { HemingwayLinkType } from '../../../types.js';
// If the link is a sitemap node and the content is NOT indexable, it should not be shown.
export function shouldShowLink(link) {
    var _a;
    if (!link)
        return false;
    if (link.__typename === HemingwayLinkType.Sitemap) {
        return ((_a = link.sitemapNode) === null || _a === void 0 ? void 0 : _a.contentIndexable) !== false;
    }
    return true;
}
//# sourceMappingURL=shouldShowLink.js.map